import { Controller } from "@hotwired/stimulus"

// Keep the icon underneath until a usable image has loaded, including cached
// loads before Stimulus connects. Failure never changes the avatar geometry.
export default class extends Controller {
  static targets = ["photo"]

  photoTargetConnected(photo) {
    photo.hidden = !(photo.complete && photo.naturalWidth > 0)
  }

  loaded() { this.photoTarget.hidden = this.photoTarget.naturalWidth === 0 }
  failed() { this.photoTarget.hidden = true }
}
